@if(worklistItem$ | async; as worklistItem){
<div class="my-2 mx-3 details-pane">
  <mat-progress-bar
    *ngIf="isFieldSaving | async"
    mode="indeterminate"
  ></mat-progress-bar>
  <form [formGroup]="detailsForm">
    <div class="header-section d-flex align-items-center my-3 mx-0">
      <h5 class="flex-grow-1 my-0">
        {{ worklistItem.mrn }} / {{ worklistItem.patientName }}
      </h5>
      <div class="lock-icon-wrapper">
        <mat-icon
          svgIcon="{{ lockStatus.Icon }}"
          matTooltip="{{ lockStatus.Tooltip }}"
        >
        </mat-icon>
      </div>
      <div
        class="urgency-label no-wrap font-weight-bold ml-3"
        [ngClass]="{
          'routine-status': worklistItem.urgency === urgencyType.Routine,
          'urgent-status': worklistItem.urgency !== urgencyType.Routine
        }"
      >
        <span>{{ urgencyDetailsText$ | async }}</span>
      </div>
      <div class="item-status-badge no-wrap font-weight-bold ml-3">
        <span>{{ getStatusDescription(worklistItem.status) }}</span>
      </div>
      <div class="close-button pl-2">
        <button
          type="button"
          class="close p-0"
          mat-icon-button
          (click)="close()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <hr *ngIf="(routineSubject | async) !== true" class="my-3" />
    @if ((editableSubject | async) && (routineSubject | async)) {
    <div class="d-flex align-items-center p-3 mb-4">
      <div class="col-6">
        <span>Urgency Level</span>
      </div>
      <div class="col-6">
        <span>Please call Everlight if you need to escalate urgency</span>
      </div>
    </div>
    }
    <div
      class="urgency-edit-container d-flex align-items-center p-3 mb-4"
      *ngIf="
        (editableSubject | async) === true && (routineSubject | async) !== true
      "
      [ngClass]="{
        success: isUrgencyDropdownSaved,
        error: shouldShowUrgencyDropdownError
      }"
    >
      <div
        class="urgency-question d-flex align-items-center col mr-3 p-0"
        #urgencyContainer
      >
        <div class="urgency-question-icon d-flex pr-2">
          <span class="material-icons" *ngIf="shouldShowUrgencyDropdownError"
            >error</span
          >
          <span class="material-icons" *ngIf="isUrgencyDropdownSaved"
            >check_circle</span
          >
        </div>
        <div class="urgency-question-text">
          <span *ngIf="shouldShowUrgencyDropdownError">
            Please select from the dropdown.</span
          >
          <span *ngIf="isUrgencyDropdownSaved">
            Study flagged as {{ urgencyDetailsText$ | async }}</span
          >
          <span
            *ngIf="!isUrgencyDropdownSaved && !shouldShowUrgencyDropdownError"
          >
            Urgency Level</span
          >
        </div>
      </div>
      <div class="col p-0">
        <mat-select
          [placeholder]="urgencyDropdownPlaceholder | async"
          formControlName="urgencyDropdown"
          id="urgency-dropdown"
          #urgencyDropdown
          class="text-left pl-3 pr-2 py-2"
          panelClass="mat-primary no-first-option-highlight-panel no-max-height-panel"
          [disableOptionCentering]="true"
          (selectionChange)="onUrgencyDropdownChanged($event, worklistItem)"
          [disabled]="(isUrgencyDropdownEnabled$ | async) === false"
          required
        >
          <mat-select-trigger>{{
            urgencyDetailsText$ | async
          }}</mat-select-trigger>
          <mat-option [disabled]="true">{{
            urgencyDropdownPlaceholder | async
          }}</mat-option>
          @for(urgencyOption of urgencyDropdownOptions | async; track
          urgencyOption){ @if(!urgencyOption.subValues){
          <mat-option
            [value]="urgencyOption.value"
            id="option-{{ urgencyOption.value }}"
          >
            {{ urgencyOption.label }}
          </mat-option>
          } @else {
          <mat-optgroup [label]="urgencyOption.label">
            <mat-option
              *ngFor="let subOption of urgencyOption.subValues"
              [value]="subOption.value"
              id="option-{{ subOption.value }}"
              >• {{ subOption.label }}
            </mat-option>
          </mat-optgroup>
          } }
        </mat-select>
      </div>
    </div>
    <hr class="mt-1 mb-3" *ngIf="editableSubject | async" />
    <div class="detail-container">
      <div class="row">
        <div class="col-6">
          <p class="input-label inline-editable-label">Date Received</p>
          <p
            class="input-field"
            [ngClass]="
              (editableSubject | async) ? '' : 'date-received-disabled'
            "
          >
            {{ worklistItem.createdAt | date: 'HH:mm:ss dd MMM, yyyy' }}
          </p>
        </div>
        <div class="col-6">
          <app-details-input
            [label]="'Referring Doctor'"
            [inputControl]="referringDoctorFormControl"
            [errorMessage]="
              inputControlErrorMessage(
                'Referring Doctor',
                referringDoctorFormControl
              )
            "
            (inputBlur)="
              handleOrderInputUpdate(
                'referringDoctor',
                referringDoctorFormControl
              )
            "
            (inputKeyUp)="
              handleInputAutocomplete(referringDoctorFormControl, $event)
            "
            [autoCompleteOptions]="filteredReferringDoctors$ | async"
          ></app-details-input>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-details-input
            [label]="'Doctor Phone'"
            [inputControl]="referringDoctorPhoneFormControl"
            [hideWarningIcon]="worklistItem.urgency === urgencyType.Routine"
            [errorMessage]="
              inputControlErrorMessage(
                'Doctor Phone',
                referringDoctorPhoneFormControl,
                worklistItem.urgency === urgencyType.Routine
              )
            "
            (inputKeyUp)="
              handleInputAutocomplete(referringDoctorPhoneFormControl, $event)
            "
            [autoCompleteOptions]="filteredReferringDoctorPhoneNo$ | async"
            (inputBlur)="
              handleOrderInputUpdate(
                'referringDoctorPhoneNo',
                referringDoctorPhoneFormControl
              )
            "
          ></app-details-input>
        </div>
        <div class="col-6">
          <app-details-input
            [label]="'Radiographer'"
            [inputControl]="radiographerNameFormControl"
            [errorMessage]="
              inputControlErrorMessage(
                'Radiographer',
                radiographerNameFormControl
              )
            "
            (inputBlur)="
              handleOrderInputUpdate(
                'radiographerName',
                radiographerNameFormControl
              )
            "
          ></app-details-input>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-details-input
            [label]="'Patient Location'"
            [inputControl]="patientLocationFormControl"
            [hideWarningIcon]="worklistItem.urgency === urgencyType.Routine"
            [errorMessage]="
              inputControlErrorMessage(
                'Patient Location',
                patientLocationFormControl,
                worklistItem.urgency === urgencyType.Routine
              )
            "
            (inputBlur)="
              handleOrderInputUpdate(
                'patientLocation',
                patientLocationFormControl
              )
            "
            (inputKeyUp)="
              handleInputAutocomplete(patientLocationFormControl, $event)
            "
            [autoCompleteOptions]="suggestedPatientLocation$ | async"
          ></app-details-input>
        </div>

        <div class="col-6">
          <button
            id="viewLinkedReferral"
            mat-stroked-button
            *ngIf="linkedReferralDetails$ | async as linkedReferral"
            (click)="viewLinkedReferral(linkedReferral)"
            type="button"
          >
            View Linked Referral
          </button>
        </div>
      </div>
    </div>
    <hr class="my-3" />
    <table
      class="w-100 mb-3"
      mat-table
      [dataSource]="scanDataSource"
      aria-label="Scaning Table"
    >
      <ng-container matColumnDef="modality">
        <th
          class="px-1 column-short"
          scope="col"
          mat-header-cell
          *matHeaderCellDef
        >
          <div class="">Modality</div>
        </th>
        <td class="px-1" mat-cell *matCellDef="let row">
          <div class="p-1">{{ row.modality }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th class="px-1" scope="col" mat-header-cell *matHeaderCellDef>
          <div class="">Study Description</div>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="px-1 break-word">{{ row.studyDescription }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="imageCount">
        <th
          class="px-1 column-medium"
          scope="col"
          mat-header-cell
          *matHeaderCellDef
        >
          <div class="">Image Count</div>
        </th>
        <td mat-cell *matCellDef="let row; let index = index">
          <app-details-input
            [inputControl]="scanTableImageCountsFormControls[index]"
            [hideWarningIcon]="worklistItem.urgency === urgencyType.Routine"
            [errorMessage]="
              inputControlErrorMessage(
                'Image Count',
                scanTableImageCountsFormControls[index],
                worklistItem.urgency === urgencyType.Routine
              )
            "
            (inputBlur)="
              handleProcedureInputUpdate(
                'expectedImageCount',
                scanTableImageCountsFormControls[index],
                row.id
              )
            "
          ></app-details-input>
        </td>
      </ng-container>
      <ng-container matColumnDef="accessionNumber">
        <th class="px-1" scope="col" mat-header-cell *matHeaderCellDef>
          <div class="">Accession</div>
        </th>
        <td mat-cell *matCellDef="let row">
          <div class="px-1">{{ row.accessionNumber }}</div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="scanColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; let i = index; columns: scanColumns"
      ></tr>
    </table>
    <div class="row no-gutters">
      <div class="col">
        <h5 class="section-header">Notes to Radiologist</h5>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col">
        <app-details-text-area
          [areaControl]="notesToRadiographerFormControl"
          (areaBlur)="updateRadiographerNotes()"
        ></app-details-text-area>
        <hr class="my-3" />
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col">
        <h5 class="section-header">Prior Images and Reports</h5>
      </div>
    </div>
    <app-priors
      [editable]="fileUploadableSubject | async"
      [item]="worklistItem"
      (priorUpdated)="updateWorklistFromPrior($event)"
    ></app-priors>
    @if(worklistItem.status === 'Reported'){
    <hr class="my-3 ml-3" />
    <div class="row no-gutters">
      <div class="col">
        <h5 class="section-header">Radiologist Findings</h5>
      </div>
    </div>
    <div class="ml-3">
      <div class="row no-gutters">
        <div class="col">
          <div
            class="w-100 inline-editable-view d-flex pre-line radiologist-findings"
          >
            {{ worklistItem.reportText }}
          </div>
        </div>
      </div>
      <div class="row no-gutters mt-2">
        <div class="col text-right">
          <button
            mat-stroked-button
            (click)="
              copyReport(
                worklistItem.mrn,
                worklistItem.patientFirstName,
                worklistItem.patientLastName,
                worklistItem.studyDateTime,
                worklistItem.reportText
              )
            "
            type="button"
          >
            Copy to Clipboard
          </button>
        </div>
      </div>
      <hr class="my-3" />
    </div>
    }
    <div id="scan-doc">
      <h5 class="font-weight-bold">Scanned Documents</h5>
      <app-scan-docs
        id="scan-doc-upload"
        [worklistItem]="worklistItem"
        [editable]="fileUploadableSubject | async"
      ></app-scan-docs>
    </div>
  </form>
</div>
} @else {
<div class="my-2 mx-3 details-pane">
  <div class="header-section d-flex justify-content-end my-3 mx-0">
    <div class="text-center">&nbsp;</div>
    <div class="close-button">
      <button class="close p-0" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <hr class="my-3" />
</div>
<div class="ph-item p-0 m-0">
  <div>
    <div class="ph-row">
      <div class="ph-col-8 big"></div>
      <div class="ph-col-12"></div>
      <div class="ph-col-2"></div>
      <div class="ph-col-4 big empty"></div>
    </div>
  </div>
</div>
<div class="ph-item p-0 m-0">
  <div>
    <div class="ph-row">
      <div class="ph-col-4"></div>
      <div class="ph-col-8 empty"></div>
      <div class="ph-col-12"></div>
    </div>
    <div class="ph-picture"></div>
  </div>
</div>
<div class="ph-item p-0 m-0">
  <div>
    <div class="ph-row">
      <div class="ph-col-10 empty"></div>
      <div class="ph-col-8 big"></div>
      <div class="ph-col-12"></div>
      <div class="ph-col-2"></div>
      <div class="ph-col-4 big empty"></div>
    </div>
  </div>
</div>
<div class="ph-item p-0 m-0">
  <div>
    <div class="ph-row">
      <div class="ph-col-10 empty"></div>
      <div class="ph-col-8 big"></div>
      <div class="ph-col-12"></div>
      <div class="ph-col-2"></div>
      <div class="ph-col-4 big empty"></div>
    </div>
  </div>
</div>
<div class="ph-item p-0 m-0">
  <div>
    <div class="ph-row">
      <div class="ph-col-10 empty"></div>
      <div class="ph-col-8 big"></div>
      <div class="ph-col-12"></div>
      <div class="ph-col-2"></div>
      <div class="ph-col-4 big empty"></div>
    </div>
  </div>
</div>
}
